// src/pages/Dashboard.tsx
import React from "react";
import { useAuth } from "../context/AuthContext.tsx";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader.tsx";
import { TAB_DESCRIPTIONS } from "../constants/tabDescriptions.ts";
import "./Dashboard.css";

export const Dashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="dashboard-page">
      <PageHeader
        icon={TAB_DESCRIPTIONS.dashboard.icon}
        title={TAB_DESCRIPTIONS.dashboard.label}
        description={TAB_DESCRIPTIONS.dashboard.description}
      />
      <div className="dashboard-content">

        {/* Beta Testing Banner */}
        <div className="beta-banner">
          <div className="beta-banner-content">
            <span className="beta-icon">🚧</span>
            <div className="beta-text">
              <h3>Beta Testing</h3>
              <p>
                This website is currently in beta testing. Help us improve by using the buttons
                in the header: <strong>Run Test</strong> to complete guided test scenarios,
                <strong> Report Bug</strong> to submit issues you encounter,
                <strong> Take Survey</strong> to share your feedback on any page, or
                <strong> Notify Friend</strong> to invite others to join. Screenshots can be
                attached for clarity. Your feedback is greatly appreciated!
              </p>
            </div>
          </div>
        </div>

        <div className="action-cards">
          {/* Link to Play Online - Standalone route */}
          <Link to="/play-online" className="action-card">
            <span className="card-icon">🎮</span>
            <h3>Play</h3>
            <p>Play chess online with friends, against AI opponents, or practice locally • Multiple board sizes and variants available</p>
          </Link>

          {/* Link to Multiplayer */}
          <Link to="/multiplayer" className="action-card">
            <span className="card-icon">🌐</span>
            <h3>Multiplayer</h3>
            <p>Create games, host matches, join games, and challenge with others online</p>
          </Link>

          {/* Link to piece catalog - Standalone route */}
          <Link to="/piece-catalog" className="action-card">
            <span className="card-icon">📚</span>
            <h3>Piece Catalog</h3>
            <p>Explore 36 unique pieces across 6 classes • View values and movement patterns</p>
          </Link>

          {/* Link to variant creator - Standalone route */}
          <Link to="/variant-creator" className="action-card">
            <span className="card-icon">🎨</span>
            <h3>Variant Creator</h3>
            <p>Create and save your own custom chess variants</p>
          </Link>

          {/* Link to AI settings - Standalone route */}
          <Link to="/ai-settings" className="action-card">
            <span className="card-icon">🤖</span>
            <h3>AI Settings</h3>
            <p>Configure AI opponent difficulty, behavior, and playing style</p>
          </Link>

          {/* Link to Leaderboard */}
          <Link to="/leaderboard" className="action-card">
            <span className="card-icon">🏆</span>
            <h3>Leaderboard</h3>
            <p>See all players ratings and rankings across all Expanded Chess variants</p>
          </Link>

          {/* Link to My Profile */}
          <Link to={`/profile/${user?.userId}`} className="action-card">
            <span className="card-icon">👤</span>
            <h3>My Profile</h3>
            <p>View your account details, membership rewards, stats and game history</p>
          </Link>

          {/* Link to Documents */}
          <Link to="/documents" className="action-card">
            <span className="card-icon">📄</span>
            <h3>Documents</h3>
            <p>Download Expanded Chess Manual with detailed explanation of Expanded Chess</p>
          </Link>

          {/* Link to Help */}
          <Link to="/help" className="action-card">
            <span className="card-icon">❓</span>
            <h3>Help</h3>
            <p>Find answers, privacy policy, terms of service, and ways to contact Expanded Chess</p>
          </Link>
        </div>
      </div>
    </div>
  );
};
